import { FileUploadWidgetConfig } from "./file-upload-widget.interface";

export const DEFAULT_CONFIG: FileUploadWidgetConfig = {
  showSelection: true,
  acceptedTypes: [],
  maxSizeMb: 2,
  allowRemoveExistingFile: false,
}

export const SPECIAL_FILE_TYPES = {
  'vnd.openxmlformats-officedocument.spreadsheetml.sheet': 'xlsx',
  'vnd.openxmlformats-officedocument.wordprocessingml.document': 'docx',
  'vnd.ms-excel': 'xls',
  'msword': 'doc',
}

export const ERRORS = {
  FILE_TYPE_NOT_ALLOWED: 'One or more of the selected file types is not allowed.',
  MAX_SIZE_EXCEEDED: 'The maximum file size is [maxSize].',
}